var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseGray2828 = function SvgIconCloseGray2828(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M6.381 6.384a.875.875 0 0 1 1.238 0l14 14a.875.875 0 0 1-1.238 1.238l-14-14a.875.875 0 0 1 0-1.238",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M21.619 6.384a.875.875 0 0 1 0 1.238l-14 14a.875.875 0 1 1-1.238-1.238l14-14a.875.875 0 0 1 1.238 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloseGray2828;